/*
 * Project: LegalPlace assistant
 * File: src\components\misc\text.js
 * Author: Azizi Amine
 * Version: 1.0
 */
// init the react environment
import React, { Component } from 'react';
import { connect } from 'react-redux';

// generate keys functions
import { generateId1 } from '../utils/misc';

// update the redux system
import {
  initOutputVariable, editVariable, initOutputOption, editOption,
} from '../../redux/actions/output';
//
import { icSetOption, icSetVariable } from '../../redux/actions/input_context';

import LpHelper from './helper';
import LpPopupPreview from '../popup_preview';


// turbo 0
import { lpGetVariableById, lpGetOptionById } from '../../logic/re_index';
import { editedDocument } from '../../redux/actions/account_settings';
import { isDocumentEdited } from '../../globals';
import LpWarning from './warning';
import lpApp from '../../app/lp_app';

// onfocus and onblur

// inputs: placeholder, id, label, helper (if it exists)
class NumberField extends Component {
  constructor(props) {
    super(props);
    // register the variable/option
    // bind the events here
    this.params = {
      ...props,
    };
    this.lpKey = generateId1(4);


    this.onValueChanged = this.onValueChanged.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);

    if (props.isDuplicate) {
      this.params.id = `${this.params.id}_${props.copy}`;
    }
  }


  // TODO: work on dispathcing things upside down, multiple, duplicate ....
  // before putting the shit into the dom
  componentWillMount() {
    // console.time("text_" + this.props.id);
    // TODO: check the duplication in the fucking existant UI component
    if (!this.props.exists) {
      this.props.initializeOutput(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id, this.props.lpKey, this.props.ovc, lpApp.indexes.variables.getVariable(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id).value);
    } else {
      this.params.label = lpApp.references.getOption(this.props.id);
    }
    // console.timeEnd("text_" + this.props.id);
  }


  componentDidUpdate() {
  }

  onValueChanged(val) {
    this.props.editOutput(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.params.id, val);
  }

  onFocus() {
    this.props.updateContext();
  }

  onBlur() {
    this.props.unUpdateContext();
  }

  render() {
    return (<div className="form-group" data-type="text-input" data-id={this.props.id} data-is-duplicate={this.props.isDuplicate} data-copy={this.props.copy}>

      <label htmlFor={`text_${this.props.lpKey}`}>
        { this.props.label }
        {' '}
        {'helper' in lpApp.references.getVariable(this.props.id) && lpApp.references.getVariable(this.props.id).helper.length > 0 && <LpHelper text={lpApp.references.getVariable(this.props.id).helper} />}
      </label>
      {(this.props.id in lpApp.references.variables) && lpApp.references.getVariable(this.props.id).warning && <LpWarning text={lpApp.references.getVariable(this.props.id).warning} id={this.props.id} type="v" />}
      <div className="fc-container">
        <input
          type="number"
          name={generateId1(1)}
          placeholder={(lpApp.references.getVariable(this.props.id) && lpApp.references.getVariable(this.props.id).placeholder) ? lpApp.references.getVariable(this.props.id).placeholder : ''}
          id={`text_${this.props.lpKey}`}
          value={this.props.value}
          onChange={evt => this.onValueChanged(evt.target.value)}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          className="form-control"
        />
      </div>

    </div>);
  }
}

const mapStateToProps = (state, ownProps) => {
  // test if exists
  let exists = false;
  let existantKey = '';
  const existantParent = '';
  let value = '';
  const realId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;

  if (ownProps.ovc === 'o') {
    if (typeof lpGetOptionById(realId) !== 'undefined') {
      exists = true;
      existantKey = lpGetOptionById(realId).key;
      ({ value } = lpGetOptionById(realId));
    }
  }
  if (ownProps.ovc === 'v') {
    if (typeof lpGetVariableById(realId) !== 'undefined') {
      exists = true;
      existantKey = lpGetVariableById(realId).key;
      ({ value } = lpGetVariableById(realId));
    }
  }
  return {
    sectionId: state.contract.currentSection,
    exists,
    existantKey,
    existantParent,
    value,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  // this case, parent = key
  initializeOutput: (id, parent, genre, value = '') => {
    if (genre === 'o') dispatch(initOutputOption(id, parent, value));
    else if (genre === 'v') dispatch(initOutputVariable(id, parent, value));
  },
  editOutput: (id, val) => {
    if (ownProps.ovc === 'o') {
      dispatch(editOption(id, val));
    } else {
      dispatch(editVariable(id, val));
    }
    if (!isDocumentEdited()) dispatch(editedDocument(true));
  },
  updateContext: () => {
    const cId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;
    const pId = ownProps.isDuplicate ? `${ownProps.parent}_${ownProps.copy}` : ownProps.parent;
    if (ownProps.ovc === 'o') dispatch(icSetOption(cId));
    else {
      dispatch(icSetVariable(cId));
      dispatch(icSetOption(pId));
    }
  },
  unUpdateContext: () => {
    if (ownProps.ovc === 'o') dispatch(icSetOption(''));
    else {
      dispatch(icSetVariable(''));
      dispatch(icSetOption(''));
    }
  },
});

const LpNumber = connect(mapStateToProps, mapDispatchToProps)(NumberField);

export default LpNumber;



// WEBPACK FOOTER //
// ./src/components/misc/number.js